import { YoloRefCoordinate } from "lib/react-stockcharts/lib/coordinates/YoloRefCoordinate/YoloRefCoordinate"
import { isEmpty } from "lodash"
import { useEffect, useMemo } from "react"

const LINES_TYPE_PROPS = {
  bust: {
    id: 'bust',
    refLabel: 'BUST',
    refLabelStroke:'hsl(340,88%,46%)',
    mainColor:'hsl(340,88%,46%)',
  },
  trailing: {
    id: 'trailing',
    refLabel: 'TRAILING',
    refLabelStroke:'hsl(27, 100%, 50%)',
    mainColor:'hsl(27, 100%, 50%)',
  },
  preBust: {
    id: 'preBust',
    refLabel: 'BUST',
    refLabelStroke:'hsla(340,88%,46%, 0.6)',
    mainColor:'hsla(340,88%,46%, 0.6)',
  },
  preTrailing: {
    id: 'preTrailing',
    refLabel: 'TRAILING',
    refLabelStroke:'hsla(27, 100%, 50%, 0.6)',
    mainColor: 'hsla(27, 100%, 50%, 0.6)',
  },
}

export const TrailingBustLine = ({ orderData, preOrderData, refOrderPrice, refLivePrice, refDecimals, priceDx }) => {

  const lineType = useMemo(() => { 
    if (!isEmpty(preOrderData)) {
      if (preOrderData.trailingStopPercent || preOrderData.trailingStopValue) return 'preTrailing'
      if (preOrderData.bustPrice) return 'preBust'
    }
    if (!isEmpty(orderData)) {
      if (orderData.side === 'buy') return orderData.trailingStopPrice < orderData.bustPrice?'bust':'trailing'
      else return orderData.trailingStopPrice < orderData.bustPrice?'trailing':'bust'
      // if (orderData.trailingStopPercent || orderData.trailingStopValue) return 'trailing'
      // if (orderData.bustPrice) return 'bust'
    }
  },[orderData, preOrderData])
  
  const refPriceFor = {
    bust: orderData.bustPrice,
    trailing: orderData.trailingStopPrice,
    preBust: preOrderData.bustPrice,
    preTrailing: 0,
  }

  return !!refPriceFor[lineType] && (
    <YoloRefCoordinate
      {...LINES_TYPE_PROPS[lineType]}
      refPrice={refPriceFor[lineType]}
      refLabelColor= 'hsl(0,0%,100%,.6)'
      refLabelFill= 'hsl(340,88%,0%)'
      refDecimals={refDecimals}
      priceDx={priceDx}
      lineGradOrient='left'
    />
  )
}